import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import LogoSVG from '@redturtle/iovisit-theme/components/layout/Logo/logo.svg';

/*
 * Customization with image
 *
 * If you have a jpg/png, do like this:
 *
 * <figure className="icon">
 *  <img src={logo} alt="" />
 * </figure>
 *
 * Note the icon class.
 */

const messages = defineMessages({
  stemma: {
    id: 'Stemma',
    defaultMessage: 'Stemma',
  },
});

const Logo = () => {
  const intl = useIntl();
  return <img src={LogoSVG} alt={intl.formatMessage(messages.stemma)} />;
};

export default Logo;
